{
  "settings": "Pengaturan",
  "yourDigitalAssistant": "Asisten Digital Anda",
  "getStarted": "Memulai",
  "login": "Gabung",
  "loggingIn": "Masuk ...",
  "darkMode": "Mode gelap",
  "clearHistory": "Hapus riwayat",
  "historyCleared": "Sejarah dihapus",
  "changeLanguage": "Bahasa",
  "termsAndConditions": "Syarat & Ketentuan",
  "messagePlaceholder": "Ketikkan pesan Anda di sini ...",
  "messagePlaceholderDisabled": "Mengetik dinonaktifkan ...",
  "feedbackTitle": "Nilai pengalaman Anda",
  "feedbackPlaceholder": "Beri tahu kami tentang hal itu (opsional)",
  "feedbackSend": "Kirim",
  "feedbackClose": "Menutup",
  "sessionExpired": "Sesi Anda telah kedaluwarsa karena tidak aktif.",
  "startNewSession": "Mulai sesi baru",
  "apiError": "Ups! Ada yang salah. Kami sedang berusaha memperbaiki ini secepat mungkin.",
  "apiErrorOffline": "Anda tidak terhubung ke internet.",
  "tryAgain": "Coba lagi",
  "startOver": "Mulai lagi",
  "chatEnded": "Obrolan telah berakhir.",
  "chatEndedThankYou": "Terima kasih telah mengobrol dengan kami!",
  "closeChat": "Menutup",
  "startNewChat": "Ngobrol lagi",
  "humanTakeoverStarted": "Anda sekarang sedang ditransfer ke layanan pelanggan ...",
  "humanTakeoverQueued": "Menunggu untuk terhubung ke agen",
  "humanTakeoverAnAgent": "Agen",
  "humanTakeoverAgentEntered": "memasuki percakapan",
  "humanTakeoverAgentLogout": "meninggalkan percakapan",
  "humanTakeoverTransfer": "Anda sedang ditransfer ke agen baru",
  "humanTakeoverEnded": "Anda sekarang sedang mengobrol dengan asisten digital Anda",
  "version": "Versi",
  "formIntroText": "Silakan isi formulir berikut untuk mulai mengobrol dengan kami.",
  "formFirstName": "Nama depan",
  "formLastName": "Nama belakang",
  "formName": "Name",
  "formEmail": "E-mail",
  "formWrongEmail": "Harap berikan alamat email yang valid.",
  "formPhone": "Phone",
  "formShipmentId": "ID Pengiriman",
  "formQuestion": "Pertanyaan Anda",
  "formAccountNumber": "Nomor rekening (untuk Pelanggan Bisnis)",
  "formAddress": "Alamat",
  "formPostcode": "Kode Pos",
  "formCity": "Kota",
  "formCountry": "Negara",
  "formSubmitButton": "Mulai obrolan",
  "formEmptyFieldError": "Tidak diizinkan kosong.",
  "formPhoneNumberValidationError": "Bukan nomor telepon yang valid.",
  "formInputIsBiggerThan50": "Harus paling banyak 50 karakter.",
  "formInputIsBiggerThan100": "Harus maksimal 100 karakter.",
  "formInputIsBiggerThan2000": "Harus paling banyak 2000 karakter.",
  "widgetEventOnline": "Pesan DA: Pengguna kembali online.",
  "widgetEventHidden": "Pesan DA: Widget disembunyikan.",
  "widgetEventVisible": "Pesan DA: Widget terlihat.",
  "widgetEventVisibleMinimized": "Pesan DA: Widget terlihat, tetapi diperkecil.",
  "widgetEventMinimized": "Pesan DA: Widget diperkecil.",
  "widgetEventMaximized": "Pesan DA: Widget dimaksimalkan.",
  "widgetEventSessionExpired": "Pesan DA: Sesi widget kedaluwarsa.",
  "widgetEventHangupHuman": "Pesan DA: Pengguna mengakhiri sesi pengambilalihan Manusia.",
  "widgetEventUserTyping": "Pesan DA: pengguna sedang mengetik.",
  "fileTooLarge": "Anda Mencoba Melampirkan File Terlalu Besar.",
  "tooManyDiles": "Anda Mencoba Melampirkan Terlalu Banyak File.",
  "fileInvalidType": "Anda Mencoba Melampirkan Jenis File yang Tidak Valid.",
  "attachmentsDropHere": "Lepaskan di sini untuk mengupload atau",
  "attachmentsBrowse": "Mencari berkas",
  "attachmentsExtenstionQuantity": "pdf atau gambar (hingga 10 file)",
  "attachmentsSize": "hingga 30 MB",
  "attachmentsFailedUploading": "Mengupload Gagal",
  "attachmentsUploading": "Mengupload ...",
  "minimizeExpandText": "Obrolan langsung dengan kami sekarang!",
  "popupWidgetNotificationMessage": "Anda menerima pesan baru!",
  "tabWidgetNotificationMessage": "Pesan baru!",
  "datepickerSendButton": "Hantar"
}
